const projects = [
	{
		title: 'Agentic Multimodal RAG (mRAG) System',
		description:
			'A three-system Retrieval-Augmented Generation pipeline evaluated on the MMDocIR benchmark (750 queries over 131 documents): a baseline hybrid BM25 + dense retriever, an advanced multimodal system retrieving page images and figures, and an agentic system built with LangGraph and LangChain featuring query-rewriter, grader, and generator agents with adaptive retry on low-confidence retrievals.',
		tags: ['Agentic AI', 'RAG', 'LangGraph', 'LangChain', 'Multimodal'],
		link: 'https://github.com/TOGUNOLUWATOBI/mRAG_on_MMDocIR',
		rarity: 'legendary',
	},
	{
		title: 'Custom Culinary AI System',
		description:
			'A recipe generation system combining a Qwen2.5-7B model fine-tuned with LoRA adapters, with a hybrid BM25 + dense retrieval RAG pipeline grounded on a curated ~20,000-recipe corpus. Deployed as containerized microservices via Docker Compose, with the quantized GGUF model served locally through Ollama.',
		tags: ['LLM Fine-Tuning', 'RAG', 'Docker', 'Ollama'],
		link: 'https://github.com/TOGUNOLUWATOBI/ai-recipe-masterclass',
		rarity: 'legendary',
	},
	{
		title: 'Bebspay - AI Mobile Banking',
		description:
			'Bebspay is a next-generation mobile banking platform built with AI-driven features for seamless payments, smart budgeting, and secure transactions. Powered by scalable backend microservices, it offers real-time analytics, fraud detection, and personalized financial insights.',
		tags: ['AI', 'Fintech', 'Microservices', 'Mobile'],
		link: 'https://github.com/TOGUNOLUWATOBI/fypbackend',
		rarity: 'epic',
	},
	{
		title: 'Ncube (Qucoon)',
		description:
			'Ncube is a cloud-based digital core banking solution, designed for financial institutions to drive innovation and growth. It offers full integration with NIBSS services, regulatory compliance, and a scalable architecture for seamless banking operations.',
		tags: ['Core Banking', 'Cloud', 'Integration', 'Compliance'],
		link: 'https://nibss-plc.com.ng/ncube/',
		rarity: 'epic',
	},
	{
		title: 'Finlake (Softgem)',
		description:
			'Finlake is an open banking platform, aggregating financial data from 50+ institutions. It provides real-time analytics, secure data management, and a robust API gateway for seamless integration and advanced financial insights.',
		tags: ['Core Banking', 'KYC', 'Analytics', 'API', 'Finance'],
		link: 'https://account.finlake.tech/',
		rarity: 'epic',
	},
	{
		title: 'VideoTube',
		description:
			'A mini YouTube-style video streaming platform built with a microservices architecture: auth, upload/transcoding, and comment services (with Discord integration) behind a React frontend. Supports video uploads, adaptive quality playback, thumbnails, and both in-app and Discord-based commenting.',
		tags: ['Video Streaming', 'Transcoding', 'Microservices', 'React'],
		link: 'https://github.com/TOGUNOLUWATOBI/VideoTube',
		rarity: 'rare',
	},
	{
		title: '5G Technology Simulations',
		description:
			'Academic research project simulating 5G Polar Code performance for the Physical Downlink/Uplink Control Channels (PDCCH/PUCCH) in MATLAB. Benchmarked BLER vs. Eb/No across decoder list sizes over AWGN and 3GPP TDL fading channels, analyzed decoding latency vs. complexity trade-offs, and modeled how UE mobility (Doppler shift) and imperfect channel estimation degrade list-decoding performance.',
		tags: ['MATLAB', '5G', 'Polar Codes', 'Wireless Communications'],
		link: 'https://github.com/TOGUNOLUWATOBI/5g-Polar-Codes-Technology',
		rarity: 'rare',
	},
];

export default projects;
